import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const ExpenseSettlementStatement = () => {
  const todayDate = moment().format("YYYY-MM-DD");
  const lastMonthDate = moment().subtract(1, "months").format("YYYY-MM-DD");

  const [searchTerm, setSearchTerm] = useState("");
  const [offerReport, setOfferReport] = useState([]);
  const [empOptions, setEmpOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [apiStatus, setApiStatus] = useState('')
  const [filterFormData, setFilterData] = useState([
    { label: "Employee", value: "" },
    { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
    { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
    { label: "Status", value: moment(todayDate).format("DD-MMM-YYYY") },
  ]);

  const dispatch = useDispatch();
  useEffect(() => {
    fetchOfferReport();
    dispatch(updateNavbarHeading("Expense Settlement Statements"));
  }, []);

  const columns = {
    Receipt: { text: "Receipt No.", visible: true },
    Name: { text: "Employee", visible: true },
    ProjectName: { text: "Project", visible: true },
    FromDate: { text: "From Date", align: "center", visible: true },
    ToDate: { text: "To Date", align: "center", visible: true },
    AdvanceAmountBASE: {
      text: "Advance Amt (\u20B9)",
      align: "end",
      visible: true,
    },
    TotalExpense: {
      text: "Total Expense (\u20B9)",
      align: "end",
      visible: true,
    },
    ApprovedAmountBASE: {
      text: "Approved Amt (\u20B9)",
      align: "end",
      visible: true,
    },
    BalanceAmountBASE: {
      text: "Balance Amt (\u20B9)",
      align: "end",
      visible: true,
    },
    SuperiorName: { text: "Manager", visible: true },
    Status: { text: "Status", visible: true },
    IsSettled: { text: "Is Settled", align: "center", visible: true },
    SettledBy: { text: "Settled By", align: "center", visible: true },
    SettledDate: { text: "Settled Date", align: "center", visible: true },
    SettledRemark: { text: "Remark", visible: true },
  };

  const formDatas = [
    { name: "Employee", type: "Select", options: [...empOptions] },
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Status", type: "Select", options: [...statusOptions] },
  ];
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const fetchOfferReport = async () => {
    setApiStatus(undefined)
    try {
      const url = `${API_URL}payroll/report/11?P_EmployeeID=&P_FromDate=&P_ToDate=&P_Status=`;

      const response = await GetServiceCaller(url);
      setApiStatus(response?.status)
      if (response?.status === 200) {
        const data = response?.data?.data?.data;
        const empOpt = response?.data?.data?.empList?.map(item => ({
          value: item?.value,
          label: item?.text
        }))
        setEmpOptions(empOpt)


        const statusOPt = response?.data?.data?.status?.map(item => ({
          value: item?.value,
          label: item?.text
        }))
        setStatusOptions(statusOPt)
        setOfferReport(data);
      }
    } catch (error) {
      console.error("Error fetching Expense Settlement Report:", error);
    }
  };


  const handleGetData = async () => {
    setApiStatus(undefined)
    try {
      const fromDate = moment(
        filterFormData.find(f => f.label === "From Date")?.value,
        "DD-MMM-YYYY"
      ).format("YYYY-MM-DD");

      const toDate = moment(
        filterFormData.find(f => f.label === "To Date")?.value,
        "DD-MMM-YYYY"
      ).format("YYYY-MM-DD");
      const empValue = filterFormData.find(f => f.label === "Employee")?.value
      const StatusValue = filterFormData.find(f => f.label === "Status")?.value

      const url = `${API_URL}payroll/report/11?P_EmployeeID=${empValue}&P_FromDate=${fromDate}&P_ToDate=${toDate}&P_Status=${StatusValue}`;

      const response = await GetServiceCaller(url);
      setApiStatus(response?.status)
      if (response?.status === 200) {
        const data = response?.data?.data?.data;
        setOfferReport(data);
      }
    } catch (error) {
      console.error("Error fetching Expense Settlement Report:", error);
    }
  };

  const handleReset = () => {
    setFilterData([
      { label: "Employee", value: "" },
      { label: "From Date", value: moment(lastMonthDate).format("DD-MMM-YYYY") },
      { label: "To Date", value: moment(todayDate).format("DD-MMM-YYYY") },
      { label: "Status", value: "" },
    ])
    fetchOfferReport();
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={offerReport}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isFilterRequired={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              handleReset={handleReset}
              isSorting={true}
              formDatas={formDatas}
              handleChange={handleChange}
              handleGetData={handleGetData}
              filterFormData={filterFormData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpenseSettlementStatement;
